import { Badge, BadgeProps } from '@/components/shadcn/badge'
import { DataItem } from '../../ChartRadial/types'
import { CardData, BadgeCardConfig } from '../types'
import { Fragment } from 'react'
import { getContrastTextColor } from '@/lib/utils'

interface BadgeCardProps {
  config: BadgeCardConfig
  data: CardData
}

export function BadgeCard({ config, data }: BadgeCardProps) {
  const badges = (data.data as DataItem[]) || []
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="grid grid-cols-2 items-stretch gap-2">
        {badges.map((badge) => {
          if (badge.color && !badge.status) {
            const bgColor = badge.color as string
            const textColor = getContrastTextColor(bgColor)
            return (
              <Fragment key={badge.description}>
                <div className="rounded text-center font-bold" style={{ backgroundColor: bgColor, color: textColor }}>
                  {badge.badge}
                </div>
                <div>{badge.description}</div>
              </Fragment>
            )
          }
          return (
            <Fragment key={badge.description}>
              <Badge
                className="w-full text-sm font-bold"
                variant={badge.status ? (badge.status as BadgeProps['variant']) : 'outline'}
              >
                {badge.badge}
              </Badge>
              <div>{badge.description}</div>
            </Fragment>
          )
        })}
      </div>
    </div>
  )
}
